module.exports = __webpack_public_path__ + "components/rewards/panda-optics/static/icon-4b27371af9127513ec49877d18ea80c5.png";